import api from '../lib/api';

const base = (tenantId: string) => `/api/v1/tenants/${tenantId}/audit-logs`;

export type AuditAction =
  | 1  // Create
  | 2  // Update
  | 3  // Delete
  | 4  // Login
  | 5  // LoginFailed
  | 6  // Logout
  | 7  // StatusChange
  | 8  // Export
  | 9  // Import
  | 13 // Read
  | 17 // TenantSwitch
  | 99; // Other

export interface AuditLogListItem {
  id: string;
  tenantId: string | null;
  action: AuditAction;
  entityType: string;
  entityId: string | null;
  summary: string;
  userId: string | null;
  userEmail: string | null;
  ipAddress: string | null;
  createdAt: string;
}

export interface AuditLogDetail extends AuditLogListItem {
  detailsJson: string | null;
  userAgent: string | null;
}

export interface AuditLogListResponse {
  total: number;
  page: number;
  pageSize: number;
  items: AuditLogListItem[];
}

export interface AuditLogFilterParams {
  entityType?: string;
  entityId?: string;
  action?: number;
  excludeAction?: AuditAction;
  userId?: string;
  from?: string;
  to?: string;
  q?: string;
  page?: number;
  pageSize?: number;
}

export const auditLogApi = {
  list: (
    tenantId: string,
    params?: AuditLogFilterParams,
    signal?: AbortSignal,
  ): Promise<AuditLogListResponse> =>
    api.get(base(tenantId), { params, signal }).then((r) => r.data),

  detail: (
    tenantId: string,
    id: string,
    signal?: AbortSignal,
  ): Promise<AuditLogDetail> =>
    api.get(`${base(tenantId)}/${id}`, { signal }).then((r) => r.data),
};
